export const FilterType = Object.freeze({
  TODAY: 'today',
  WEEK: 'week',
  MONTH: 'month',
  YEAR: 'year',
  ALL: 'all',
  CREATOR: 'creator',
})
